module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-planner-f190b8f243448f633171a10c78eeca64.jpg";